import { render } from "./StudentSocialGroupsView.vue?vue&type=template&id=5ff5430f&scoped=true"
import script from "./StudentSocialGroupsView.vue?vue&type=script&lang=js"
export * from "./StudentSocialGroupsView.vue?vue&type=script&lang=js"

import "./StudentSocialGroupsView.vue?vue&type=style&index=0&id=5ff5430f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff5430f"]])

export default __exports__